import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'

import { apiFetch } from '@/lib/api'

export const systemStatusSchema = z.object({
  product: z.string(),
  version: z.string(),
  environment: z.string(),
  authMode: z.string(),
  googleSignIn: z.boolean(),
  database: z.object({ provider: z.string(), state: z.string(), pendingMigrations: z.number() }),
  jira: z.object({ configured: z.boolean(), allowWrites: z.boolean(), baseUrl: z.string().nullable(), projectKey: z.string() }),
  mcpPath: z.string(),
  apiKeys: z.number(),
})

export type SystemStatus = z.infer<typeof systemStatusSchema>

export function useSystemStatus() {
  return useQuery({ queryKey: ['system', 'status'], queryFn: () => apiFetch('/api/system/status', systemStatusSchema) })
}
